/*
 * Copyright (c) 2024 Paul Ostrowski. All rights reserved.
 *
 * This software is the proprietary information of Paul Ostrowski.
 * Unauthorized copying, modification, or distribution of this code, via any medium, is strictly prohibited.
 * This code is proprietary and confidential.
 *
 * For licensing inquiries, contact Paul Ostrowski at postrowski@gmail.com.
*/

import React, { useState } from "react";

interface CharacterModalProps {
  isOpen: boolean;
  onClose: (showInFuture: boolean, accept: boolean) => void;
}

const MessageModal: React.FC<CharacterModalProps> = ({ isOpen, onClose }) => {
  const [checked, setChecked] = useState<boolean>(true);

  // Ensure modal is not rendered if not open
  if (!isOpen) return null;

  return (
    <div className="modal-overlay" onClick={() => onClose(true, false)}>
      <div className="modal-content warn-content" onClick={(e) => e.stopPropagation()}>
        <span className="modal-title warn-title">Feature Under Development</span>
        <div>
          <p>The PN / NPC feature is still under development.</p>
          <p>You should expect some things may not work perfectly.</p>
          <p>While I'm actively working to fix issues, please email me to report bugs (<a href="mailto:postrowski@gmail.com?subject=GGG Stats Block" target="_blank" rel="noreferrer">postrowski@gmail.com</a>).</p>
          <p>Feedback (good or bad) is always appreciated.</p>
          <p>Thanks!</p>
          <br/>
          <label>
            <input
              type="checkbox"
              checked={checked}
              onChange={() => setChecked((oldVal) => !oldVal)}
            />
            Show this message in the future
          </label>
          <br/>
          <p>Continue anyway?</p>
        </div>
        <div className="modal-actions">
          <button type="button" onClick={() => onClose(true, false)}>Cancel</button>
          <button type="button" onClick={() => onClose(checked, true)}>Accept</button>
        </div>
      </div>
    </div>
  );
};

export default MessageModal;
